export const STORE_CREATE_REVIEWS_REQUEST = 'STORE_CREATE_REVIEW_REQUEST'
export const STORE_CREATE_REVIEWS_SUCCESS = 'STORE_CREATE_REVIEW_SUCCESS'
export const STORE_CREATE_REVIEWS_FAIL = 'STORE_CREATE_REVIEW_FAIL'
export const STORE_CREATE_REVIEWS_RESET = 'STORE_CREATE_REVIEW_RESET'

export const STORE_LIST_REVIEWS_REQUEST = 'STORE_LIST_REVIEW_REQUEST'
export const STORE_LIST_REVIEWS_SUCCESS = 'STORE_LIST_REVIEW_SUCCESS'
export const STORE_LIST_REVIEWS_FAIL = 'STORE_LIST_REVIEW_FAIL'
export const STORE_LIST_REVIEWS_RESET = 'STORE_LIST_REVIEW_RESET'